export default {
	"billConfirm": {
		"PackingQty": "ปริมาณสินค้า",
		"settlementStatus": "สถานะการเรียกเก็บเงิน",
		"keywords": "คีย์เวิร์ด",
		"isConfirm": "ยืนยัน",
		"isAdjust": "ปรับเปลี่ยนหรือไม่",
		"isAbnormal": "ผิดปกติหรือไม่",
		"billPrice": "จำนวน",
		"routeBill": "ส่งใบเรียกเก็บเงิน",
		"billconfirmdeliverVehicleType": "ประเภทการดำเนินงาน",
		"fixWorkAmount": "ปริมาณธุรกิจปัจจุบัน",
		"serviceDepartment": "หน่วยงาน",
		"billingAmount": "จำนวนเงินที่เรียกเก็บ",
		"billingResource": "แหล่งที่เรียกเก็บเงิน",
		"correctionItemsTitle": "การแก้ไขข้อมูลงานใบตราส่งสินค้า",
		"errorMessageTips": "ข้อความแจ้งความผิดพลาด"
	},
	"billReconciliation": {
		"printHandleDetail": "พิมพ์รายละเอียด",
		"chooseBillTips": "เลือกข้อมูลที่ต้องการส่งออกในใบเรียกเก็บเงิน",
		"sendWeight": "น้ำหนักตามจริง",
		"receiptWeight": "น้ำหนักตามจริง",
		"locationNumber": "จำนวนสถานที่",
		"billPrinting": "พิมพ์ใบเรียกเก็บเงิน",
		"addPartner": "เพิ่มคู่ค้า",
		"addSize": "เพิ่มสถานที่",
		"addUser": "เพิ่มผู้ใช้",
		"addRoles": "เพิ่มหน้าที่",
		"printDataChooseTips": "กรุณาทำเครื่องหมายถูกที่การพิมพ์ข้อมูล"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/billPayable/billPayable.js